<!--
 * @Author: w9013327 v-maijiahua@oppo.com
 * @Date: 2022-11-21 16:42:43
 * @LastEditors: W9013327 v-maijiahua@oppo.com
 * @LastEditTime: 2023-03-30 16:48:35
 * @FilePath: \sns-user-frontend\src\views\thread\web\components\author.vue
 * @Description: 详情页作者信息
-->
<template>
  <div class="author-info">
    <Avatar :avatarInfo="avatarInfo" :size="72"
      :iconSize="21"
    >
      <div class="nickname">
        <span>{{ authorInfo.nickname }}</span>
        <Tag v-if="tagName" :text="tagName" />
      </div>
    </Avatar>
    <p v-if="authorInfo.signature" class="signature">{{ authorInfo.signature }}</p>
    <div class="follow-count">
      <div @click="showFollowList('follower')">
        <span>{{ $numFormat(authorInfo.userStatVO.followerCount) }}</span>
        <span>{{ $t('follower', authorInfo.userStatVO.followerCount) }}</span>
      </div>
      <div @click="showFollowList('following')">
        <span>{{ $numFormat(authorInfo.userStatVO.followingCount) }}</span>
        <span>{{ $t('following') }}</span>
      </div>
    </div>
    <Follow :relation="authorInfo.relation" :uid="authorInfo.uid" @change="onChangeFollowStatus" followFrom="Details_Main" v-if="authorInfo.uid !== uid" />
    <ObButton :text="$t('message')" backgroundColor="var(--background-light)" fontColor="var(--text-primary)" class="message-btn" :callBack="() => { chatVisible = true }"
      v-if="authorInfo.uid !== uid" />
  </div>
  <FollowList v-model="visible" :uid="authorInfo.uid" :listType="listType" />
  <Chat v-model="chatVisible" :chatInfo="chatInfo" />
</template>

<script setup>
import { useUserStore } from '@/stores/user'
import { storeToRefs } from 'pinia';
import Tag from '@/components/themeTag'
import FollowList from '@/components/web/followList'
const userStore = useUserStore()
const { uid } = storeToRefs(userStore)
const route = useRoute()
const { proxy } = getCurrentInstance()
const props = defineProps({
  modelValue: {
    type: Object,
    default: () => { }
  }
})

const authorInfo = ref({})
const avatarInfo = ref(null)
const chatVisible = ref(false)
const chatInfo = ref({
  uid: props.modelValue.uid,
  avatar: props.modelValue.avatar,
  nickname: props.modelValue.nickname,
  iconLink: props.modelValue.userIconVO ? props.modelValue.userIconVO.link : '',
})
const tagName = computed(() => {
  let name = authorInfo.value.tag || ''
  switch (authorInfo.value.identityType) {
    case 1:
      name = proxy.$t('circleOwner')
      break
    case 2:
      name = proxy.$t('circleAssistant')
      break
    default:
  }
  return name
})

// 修改关注状态
const onChangeFollowStatus = ({ relation }) => {
  authorInfo.value.relation = relation
}

// 设置头像数据
watch(() => props.modelValue, (val) => {
  if (val && Object.keys(val).length) {
    authorInfo.value = { ...val }
    const { uid: id, avatar, iconLink: icon } = val
    avatarInfo.value = { id, icon, avatar }
  }
}, {
  immediate: true,
  deep: true
})

// 关注/粉丝列表抽屉
const visible = ref(false)
let listType = ref('following')
const showFollowList = (type) => {
  proxy.$ga(type === 'following' ? 'following' : 'followers', {
    "screen_name": route.name,
    "userId": props.modelValue.uid
  })
  visible.value = true
  listType.value = type
}


</script>

<style lang="postcss" scoped>
.author-info {
  width: 264px;

  :deep(.avatar) {
    display: block;
  }

  .nickname {
    display: flex;
    flex-flow: row wrap;
    align-items: center;
    justify-content: flex-start;
    margin-top: 16px;
    word-break: break-all;

    span {
      font-size: 24px;
      line-height: 120%;
      margin-right: 8px;
    }
  }

  .signature {
    display: -webkit-box;
    margin-top: 16px;
    font-size: 16px;
    word-break: break-word;
    line-height: 120%;
  }

  .follow-count {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: flex-start;
    margin-top: 24px;

    div {
      display: flex;
      flex-flow: column wrap;
      align-items: flex-start;
      justify-content: flex-start;
      margin-right: 48px;
      cursor: pointer;

      span {
        font-size: 16px;
        line-height: 120%;

        &:last-child {
          margin-top: 4px;
        }
      }
    }
  }

  .follow {
    width: 180px !important;
    margin-top: 43px;

    :deep(span) {
      font-family: "orbit-M";
    }
  }
}

.message-btn {
  width: 180px;
  height: 38px;
  font-family: "orbit-M";
  font-size: 14px;
  margin-top: 16px;
  margin-left: 0px !important;
}
</style>